import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20style%20illustration%20of%20a%20young%20mage%20standing%20on%20a%20mountain%20peak%20overlooking%20a%20magical%20ancient%20city%2C%20dramatic%20sky%20with%20golden%20and%20crimson%20clouds%2C%20dynamic%20composition%2C%20cinematic%20lighting%2C%20warm%20atmospheric%20tone%2C%20fantasy%20art%20style%2C%20epic%20scale%2C%20soft%20background%20details&width=1920&height=1080&seq=hero-bg-manga-01&orientation=landscape"
        alt="全职法师漫画 - 八仔漫画网"
        title="全职法师漫画在线免费阅读 - 八仔漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex items-center px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-accent-300 text-sm md:text-base font-medium mb-3 tracking-wider">
            —— 八仔漫画网 ——
          </p>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight mb-4">
            {t('home.heroTitle')}
          </h1>
          <p className="text-xl md:text-2xl font-heading font-bold text-white/90 mb-4">
            {t('home.heroSubtitle')}
          </p>
          <p className="text-sm md:text-base text-white/70 max-w-lg mb-8 leading-relaxed">
            {t('home.heroDesc')}
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <Link
              to="/comic/quanzhi-fashi"
              className="inline-flex items-center px-7 py-3 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('home.heroCta')}
              <div className="w-4 h-4 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
            <Link
              to="/category/xuanhuan"
              className="inline-flex items-center px-7 py-3 rounded-full text-sm font-semibold border-2 border-white/40 text-white hover:bg-white/10 hover:border-white/60 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('home.heroBrowse')}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-white/60 text-xs">
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            <span>1289万+ 次阅读</span>
          </div>
          <span className="text-white/30">|</span>
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400"></i>
            </div>
            <span>9.6 分</span>
          </div>
          <span className="text-white/30">|</span>
          <span>连载中 · 每周更新</span>
        </div>
      </div>
    </section>
  );
}